import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format date to display
export function formatDate(dateStr) {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

// Format currency
export function formatCurrency(value) {
  if (value === null || value === undefined || value === 'N/A') return 'N/A';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(value);
}

// Get status color class
export function getStatusClass(status) {
  switch (status?.toLowerCase()) {
    case 'active':
      return 'status-active';
    case 'expired':
      return 'status-expired';
    case 'revoked':
      return 'status-revoked';
    case 'suspended':
      return 'status-revoked';
    case 'pending':
      return 'status-pending';
    default:
      return 'bg-zinc-100 text-zinc-600 border-zinc-200';
  }
}

// Download blob as file
export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

// Truncate text
export function truncate(str, length = 50) {
  if (!str) return '';
  if (str.length <= length) return str;
  return str.substring(0, length) + '...';
}
